@if (loading()) {
<app-page-loader loadingType="surveyBuilder" />
} @else {
<app-survey-header [survey]="survey"></app-survey-header>

<div class="h-[calc(100%-var(--spacing)*15)] flex flex-col md:flex-row">
  <!-- Left menu -->
  <aside class="basis-full md:basis-1/3 lg:basis-1/4 pb-6 border-r border-gray-200 bg-white shadow-sm dark:border-gray-800 dark:bg-white/3 p-4 overflow-x-hidden">
    <div class="">
        <div class="mb-4 flex items-center justify-between">
          <h2 class="text-lg font-semibold text-gray-800 dark:text-white">
            Questions
          </h2>

          @if (canEdit()) {
          <div class="relative shrink-0" data-add-menu>
            <button type="button"
              (click)="toggleAddMenu($event)"
              class="flex items-center gap-1 px-3 py-2 text-blue-400 hover:text-blue-500 dark:text-blue-300 dark:hover:text-blue-100"
            >
              <span class="text-sm text-gray-400">Add</span>
              <!--svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/></svg-->
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M440-280h80v-160h160v-80H520v-160h-80v160H280v80h160v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>
            </button>
            @if (openAddMenu) {
            <div (click)="$event.stopPropagation()" class="absolute right-0 z-20 mt-2 w-48 rounded-xl border border-gray-200 bg-white p-1 shadow-lg dark:border-gray-700 dark:bg-gray-900">
              <button type="button" (click)="addQuestion(QuestionType.Numeric)"       class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">Numeric</button>
              <button type="button" (click)="addQuestion(QuestionType.Verbatim)"      class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">Verbatim</button>
              <button type="button" (click)="addQuestion(QuestionType.MultipleChoice)" class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">Multiple Choice</button>
              <button type="button" (click)="addQuestion(QuestionType.Boolean)"       class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">Boolean</button>
              <button type="button" (click)="addQuestion(QuestionType.ThankYouMessage)" class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">Thank You Message</button>
              @for (type of basicQuestionTypes; track type) {
              <button type="button" (click)="addQuestion(type)" class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">{{ getQuestionTypeLabel(type) }}</button>
              }
            </div>
            }
          </div>
          }
        </div>

        <div class="space-y-2" cdkDropList [cdkDropListDisabled]="!canEdit()" (cdkDropListDropped)="onQuestionDrop($event)">
          @for (question of questions; track $index; let i = $index) {
            <button
              type="button"
              cdkDrag
              cdkDragPreviewClass="question-drag-preview"
              [cdkDragDisabled]="!canEdit()"
              [id]="'question-' + question.questionCode"
              (click)="selectQuestion(question)"
              class="w-full rounded-xl border px-4 py-3 text-left transition-colors relative"
              [class.border-brand-500]="selectedQuestionId === question.questionCode"
              [class.dark:border-gray-500]="selectedQuestionId === question.questionCode"
              [class.bg-brand-50]="selectedQuestionId === question.questionCode"
              [class.dark:bg-gray-700]="selectedQuestionId === question.questionCode"
              [class.border-gray-200]="selectedQuestionId !== question.questionCode"
              [class.border-green-200]="getQuestionChangeStatus(question) === 'new'"
              [class.border-orange-200]="getQuestionChangeStatus(question) === 'modified'"
            >
            @if (getQuestionChangeStatus(question) === 'new') {
              <span class="absolute top-1 left-1 inline-block h-2 w-2 rounded-full bg-success-500" title="New question"></span>
            } @else if (getQuestionChangeStatus(question) === 'modified') {
              <span class="absolute top-1 left-1 inline-block h-2 w-2 rounded-full bg-warning-500" title="Unsaved changes"></span>
            }

              <div class="flex items-center gap-3">
                @if (canEdit()) {
                <div cdkDragHandle class="shrink-0 cursor-grab text-gray-300 hover:text-gray-500 active:cursor-grabbing dark:text-gray-600 dark:hover:text-gray-400" (click)="$event.stopPropagation()">
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path d="M7 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/></svg>
                </div>
                }
                <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-gray-200 bg-gray-50 text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200">
              @if (QuestionTypeMeta[question.questionType].icon == "pin"){
                  <span class="h-5 w-5 object-contain mr-1"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm100-200h46v-240h-36l-70 50 24 36 36-26v180Zm124 0h156v-40h-94l-2-2q21-20 34.5-34t21.5-22q18-18 27-36t9-38q0-29-22-48.5T458-600q-26 0-47 15t-29 39l40 16q5-13 14.5-20.5T458-558q15 0 24.5 8t9.5 20q0 11-4 20.5T470-486l-32 32-54 54v40Zm296 0q36 0 58-20t22-52q0-18-10-32t-28-22v-2q14-8 22-20.5t8-29.5q0-27-21-44.5T678-600q-25 0-46.5 14.5T604-550l40 16q4-12 13-19t21-7q13 0 21.5 7.5T708-534q0 14-10 22t-26 8h-18v40h20q20 0 31 8t11 22q0 13-11 22.5t-25 9.5q-17 0-26-7.5T638-436l-40 16q7 29 28.5 44.5T680-360ZM160-240h640v-480H160v480Zm0 0v-480 480Z"/></svg></span>
              }
              @else if (QuestionTypeMeta[question.questionType].icon == "notes"){
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M120-240v-80h480v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>
              }
              @else if (QuestionTypeMeta[question.questionType].icon == "check_box"){
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="m424-312 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>
              }
              @else if (QuestionTypeMeta[question.questionType].icon == "toggle_on"){
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M280-240q-100 0-170-70T40-480q0-100 70-170t170-70h400q100 0 170 70t70 170q0 100-70 170t-170 70H280Zm0-80h400q66 0 113-47t47-113q0-66-47-113t-113-47H280q-66 0-113 47t-47 113q0 66 47 113t113 47Zm485-75q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35Zm-285-85Z"/></svg>
              }
              @else if (QuestionTypeMeta[question.questionType].icon == "tune"){
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"/></svg>
              }
              @else if (QuestionTypeMeta[question.questionType].icon == "dashboard_customize"){
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M120-520v-320h320v320H120Zm80-80h160v-160H200v160Zm-80 480v-320h320v320H120Zm80-80h160v-160H200v160Zm320-320v-320h320v320H520Zm80-80h160v-160H600v160Zm40 480v-120H520v-80h120v-120h80v120h120v80H720v120h-80ZM360-600Zm0 240Zm240-240Zm40 240Z"/></svg>
              }
              @else if (QuestionTypeMeta[question.questionType].icon == "directions_car"){
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M240-200v40q0 17-11.5 28.5T200-120h-40q-17 0-28.5-11.5T120-160v-320l84-240q6-18 21.5-29t34.5-11h440q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T800-120h-40q-17 0-28.5-11.5T720-160v-40H240Zm-8-360h496l-42-120H274l-42 120Zm-32 80v200-200Zm100 160q25 0 42.5-17.5T360-380q0-25-17.5-42.5T300-440q-25 0-42.5 17.5T240-380q0 25 17.5 42.5T300-320Zm360 0q25 0 42.5-17.5T720-380q0-25-17.5-42.5T660-440q-25 0-42.5 17.5T600-380q0 25 17.5 42.5T660-320Zm-460 40h560v-200H200v200Z"/></svg>
              }
              @else {
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor"><path d="M200-120q-33 0-56.5-23.5T120-200v-160h80v160h160v80H200Zm560 0H600v-80h160v-160h80v160q0 33-23.5 56.5T760-120ZM120-760q0-33 23.5-56.5T200-840h160v80H200v160h-80v-160Zm720 0v160h-80v-160H600v-80h160q33 0 56.5 23.5T840-760ZM515.5-254.5Q530-269 530-290t-14.5-35.5Q501-340 480-340t-35.5 14.5Q430-311 430-290t14.5 35.5Q459-240 480-240t35.5-14.5ZM444-393h73q0-34 8-52t35-45q35-35 46.5-56.5T618-598q0-54-39-88t-99-34q-50 0-86 26t-52 74l66 27q7-26 26.5-42.5T480-652q29 0 46.5 15.5T544-595q0 20-9.5 37.5T502-521q-33 29-45.5 56T444-393Z"/></svg>
              }
                </div>
                <div class="min-w-0 flex-1">
                  <div class="items-center gap-2">
                    <p class="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400">
                      <span>{{ i + 1 }}.</span>
                      {{ question.questionCode }}
                    </p>
                    <p class="truncate text-sm font-medium text-gray-800 dark:text-white">
                      {{ question.title || 'Untitled question' }}
                    </p>
                  </div>
                </div>


                @if (canEdit()) {
                <div class="relative shrink-0" data-question-menu>
                  <button type="button" class="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                  (click)="toggleQuestionMenu(question.questionCode, $event); $event.stopPropagation()"
                  >
                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M10 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM10 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM10 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/></svg>
                  </button>

                  @if (openMenuQuestionId === question.questionCode) {
                  <div (click)="$event.stopPropagation()" class="absolute right-0 z-20 mt-2 w-40 rounded-xl border border-gray-200 bg-white p-1 shadow-lg dark:border-gray-700 dark:bg-gray-900">
                      <button type="button" [disabled]="i === 0"
                        (click)="moveQuestionUp(question, $event)"
                        class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40 dark:text-gray-300 dark:hover:bg-gray-800"
                      >
                      Move up
                      </button>

                      <button type="button" [disabled]="i === orderedQuestions.length - 1"
                        (click)="moveQuestionDown(question, $event)"
                        class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40 dark:text-gray-300 dark:hover:bg-gray-800"
                      >
                      Move down
                      </button>

                      <button type="button"
                        (click)="duplicateQuestion(question, $event)"
                        class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
                      >
                      Duplicate
                      </button>

                      <button type="button"
                        (click)="deleteQuestionFromMenu(question, $event)"
                        class="block w-full rounded-lg px-3 py-2 text-left text-sm text-error-600 hover:bg-error-50 dark:hover:bg-error-500/10"
                      >
                      Delete
                      </button>
                  </div>
                  }
                </div>
                }

              </div>
            </button>
          }
        </div>
    </div>
  </aside>

  <!-- Right config panel -->
  <section class="flex flex-col basis-full md:basis-2/3 lg:basis-3/4 p-3 md:p-4">
    <div class="flex mb-2">
      <app-breadcrumb class="flex-1" [items]="[{ label: 'Surveys', route: '/surveys' },{ label: 'Edit Survey' }]"/>
      @if (canEdit()) {
      <div class="flex items-center gap-2">
        @if(pendingChangesCount > 0){
        <button type="button" [disabled]="pendingChangesCount == 0" (click)="requestDiscard()"
            class="rounded-lg border border-gray-400 bg-white px-3 py-1.5 text-md font-medium text-gray-600 hover:bg-gray-100
            disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Discard
        </button>
        }
        <button type="button" [disabled]="pendingChangesCount == 0 || hasDuplicateChoiceValues || hasMissingNa" (click)="requestSave()"
            class="rounded-lg border border-blue-600 bg-blue-600 px-4 py-2 text-lg font-medium text-white hover:bg-white hover:text-blue-600
            disabled:opacity-50 disabled:bg-white disabled:border-gray-400 disabled:text-gray-600 disabled:hover:text-gray-600 disabled:cursor-not-allowed"
        >
          Save
          @if(pendingChangesCount > 0){
          <span class="text-xs">
            ({{ pendingChangesCount }} change{{ pendingChangesCount === 1 ? '' : 's' }})
          </span>
          }
        </button>
      </div>
      }
    </div>
    @if (hasDuplicateChoiceValues) {
    <p class="mt-1 text-right text-xs text-error-600">Some questions have duplicate choice values. Fix them before saving.</p>
    }
    @if (hasMissingNa) {
    <p class="mt-1 text-right text-xs text-error-600">Some questions have "Not Applicable" enabled without a value. Fill it in or disable it before saving.</p>
    }

  @if (selectedQuestion; as question) {
    <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/3 overflow-y-scroll">
      <div class="mb-6 flex items-start justify-between">
        <div>
          <h2 class="text-xl font-semibold text-gray-800 dark:text-white">
            Configure Question
          </h2>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Configure the selected question.
          </p>
        </div>
        @if (canEdit()) {
        <button type="button" (click)="requestDeleteQuestion(question)" class="rounded-lg border border-error-300 px-3 py-2 text-sm text-error-600">
          Delete
        </button>
        }
      </div>

      <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div class="md:col-span-2">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Question code
          </label>
          <input [ngModel]="question.questionCode" (ngModelChange)="onQuestionCodeChange(question, $event)" [disabled]="!canEditQuestionCode()" type="text" class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm dark:border-gray-700 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
        </div>

        <div class="md:col-span-2">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Question title
          </label>
          <input [(ngModel)]="question.title" [disabled]="!canEdit()" type="text" class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm dark:border-gray-700 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
        </div>

        <div class="md:col-span-2">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Question order
          </label>
          <input [ngModel]="question.questionOrder" (ngModelChange)="onQuestionOrderChange(question, $event)" [disabled]="!canEdit()" type="number" class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm dark:border-gray-700 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
        </div>

        @if(false && question.skipCondition){
        <div class="md:col-span-2">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Skip condition
          </label>
          <input [(ngModel)]="question.skipCondition" [disabled]="!canEdit()" type="text" class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm dark:border-gray-700 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
        </div>
        }

        <div class="md:col-span-2">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Display condition
          </label>
          <input [(ngModel)]="question.displayCondition" [disabled]="!canEdit()" type="text" class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm dark:border-gray-700 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Question type
          </label>

          <select
            [ngModel]="question.questionType"
            (ngModelChange)="changeQuestionType(question, $event)"
            [disabled]="!canEdit()"
            class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm dark:border-gray-700 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <option [ngValue]="QuestionType.Numeric">Numeric</option>
            <option [ngValue]="QuestionType.Verbatim">Verbatim</option>
            <option [ngValue]="QuestionType.MultipleChoice">Multiple Choice</option>
            <option [ngValue]="QuestionType.Boolean">Boolean</option>
            <option [ngValue]="QuestionType.ThankYouMessage">Thank You Message</option>
            @for (type of basicQuestionTypes; track type) {
            <option [ngValue]="type">{{ getQuestionTypeLabel(type) }}</option>
            }
          </select>
        </div>

        <div class="flex items-center pt-7">
          <label class="flex items-center gap-3 text-sm font-medium text-gray-700 dark:text-gray-300">
            <input [(ngModel)]="question.mandatory" [disabled]="!canEdit()" type="checkbox" class="h-4 w-4 disabled:cursor-not-allowed"/>
            Required question
          </label>
        </div>
      </div>

      <div class="my-6 border-t border-gray-200 dark:border-gray-800 text-gray-700 dark:text-gray-300"></div>
      @switch (question.questionType) {
        @case (QuestionType.Numeric) {
          <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
            <div>
              <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                Min
              </label>
              <input [(ngModel)]="question.minValue" [disabled]="!canEdit()" type="number" class="h-11 w-full text-gray-700 dark:text-gray-300 rounded-lg border border-gray-300 px-4 dark:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"/>
            </div>

            <div>
              <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                Max
              </label>
              <input [(ngModel)]="question.maxValue" [disabled]="!canEdit()" type="number" class="h-11 w-full text-gray-700 dark:text-gray-300 rounded-lg border border-gray-300 px-4 dark:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"/>
            </div>

            <div>
              <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                Step
              </label>
              <input [(ngModel)]="question.step" [disabled]="!canEdit()" type="number" class="h-11 w-full text-gray-700 dark:text-gray-300 rounded-lg border border-gray-300 px-4 dark:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"/>
            </div>
          </div>

          <div class="mt-5">
            <ng-container *ngTemplateOutlet="naConfig; context: { $implicit: question }"></ng-container>
          </div>
        }

        @case (QuestionType.MultipleChoice) {
          <div class="space-y-4">
              <div class="space-y-3">
              @for (choice of getOrderedChoices(question); track $index; let i = $index) {
                <div class="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-gray-800/50">
                  <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white text-xs font-semibold text-gray-500 dark:bg-gray-900 dark:text-gray-400">
                      {{ i + 1 }}
                  </div>

                  <div class="flex flex-1 items-end gap-2">
                    <div class="flex-1">
                      <label class="mb-1 block text-xs text-gray-400 dark:text-gray-500">Text</label>
                      <input [(ngModel)]="choice.choiceText" [disabled]="!canEdit()" type="text" class="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
                    </div>
                    <div class="w-28 shrink-0">
                      <label class="mb-1 block text-xs text-gray-400 dark:text-gray-500">Value</label>
                      <input [(ngModel)]="choice.choiceValue" [disabled]="!canEdit()" type="text" class="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"
                        [class.border-error-500]="isDuplicateChoiceValue(question, choice)"/>
                    </div>
                  </div>

                  @if (canEdit()) {
                  <div class="flex items-center gap-1">
                      <button
                      type="button"
                      (click)="moveChoiceUp(question, choice)"
                      [disabled]="i === 0"
                      class="rounded-lg p-2 text-gray-500 hover:bg-white hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-40 dark:hover:bg-gray-900 dark:hover:text-white"
                      >
                      ↑
                      </button>

                      <button
                      type="button"
                      (click)="moveChoiceDown(question, choice)"
                      [disabled]="i === getOrderedChoices(question).length - 1"
                      class="rounded-lg p-2 text-gray-500 hover:bg-white hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-40 dark:hover:bg-gray-900 dark:hover:text-white"
                      >
                      ↓
                      </button>

                      <button
                      type="button"
                      (click)="removeChoice(question, choice)"
                      class="rounded-lg p-2 text-error-500 hover:bg-error-50 dark:hover:bg-error-500/10"
                      >
                      Delete
                      </button>
                    </div>
                  }
                  </div>
              }
              </div>

              @if (hasDuplicateChoiceValuesIn(question)) {
              <p class="text-xs text-error-600">Choice values must be unique.</p>
              }

              @if (canEdit()) {
              <button
              type="button"
              (click)="addChoice(question)"
              class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
              >
              Add choice
              </button>
              }

          </div>
        }

        @case (QuestionType.Verbatim) {
          <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
            <div>
              <label class="mb-1.5 block text-sm font-medium">
                Placeholder
              </label>
              <input [(ngModel)]="question.placeHolderLabel" [disabled]="!canEdit()" type="text" class="h-11 w-full rounded-lg border border-gray-300 px-4 dark:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"/>
            </div>

            <div>
              <label class="mb-1.5 block text-sm font-medium">
                Max length
              </label>
              <input [(ngModel)]="question.maxValue" [disabled]="!canEdit()" type="number" class="h-11 w-full rounded-lg border border-gray-300 px-4 dark:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"/>
            </div>
          </div>
        }

        @case (QuestionType.Boolean) {
          <div class="space-y-4">
            <div class="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800/50">
              <div class="space-y-4">
                <div class="flex items-center gap-3">
                  <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-xs font-semibold text-gray-500 dark:bg-gray-900 dark:text-gray-400">0</div>
                  <div class="flex-1">
                    <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">False label</label>
                    <input [ngModel]="getBooleanChoiceText(question, '0')" (ngModelChange)="setBooleanChoiceText(question, '0', $event)" [disabled]="!canEdit()" type="text" class="h-11 w-full rounded-lg border border-gray-300 bg-white px-4 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
                  </div>
              </div>
              <div class="flex items-center gap-3">
                <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-xs font-semibold text-gray-500 dark:bg-gray-900 dark:text-gray-400">1</div>
                  <div class="flex-1">
                    <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">True label</label>
                    <input [ngModel]="getBooleanChoiceText(question, '1')" (ngModelChange)="setBooleanChoiceText(question, '1', $event)" [disabled]="!canEdit()" type="text" class="h-11 w-full rounded-lg border border-gray-300 bg-white px-4 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white disabled:opacity-60 disabled:cursor-not-allowed"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @case (QuestionType.ThankYouMessage) {
          <div>
            <label class="mb-2 block text-sm font-medium">
              Message
            </label>
            <textarea [(ngModel)]="question.title" [disabled]="!canEdit()" rows="5" class="w-full rounded-lg border border-gray-300 px-4 py-3 dark:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"></textarea>
          </div>
        }

        @default {
          <!-- CustomizedI / CustomizedII / BrandModel: basic fields only, plus Not Applicable -->
          @if (isBasicQuestionType(question)) {
            <ng-container *ngTemplateOutlet="naConfig; context: { $implicit: question }"></ng-container>
          }
        }
      }

      <ng-template #naConfig let-question>
        <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
          <div class="flex items-center">
            <label class="flex items-center gap-3 text-sm font-medium text-gray-700 dark:text-gray-300">
              <input [ngModel]="isNaEnabled(question)" (ngModelChange)="toggleNa(question, $event)" [disabled]="!canEdit()" type="checkbox" class="h-4 w-4 disabled:cursor-not-allowed"/>
              Not Applicable
            </label>
          </div>

          @if (isNaEnabled(question)) {
          <div class="md:col-span-2">
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Not Applicable value
            </label>
            <input [value]="question.na" (input)="onNaInput(question, $any($event.target))" [disabled]="!canEdit()" type="text" placeholder="e.g. not_applicable"
              class="h-11 w-full rounded-lg border px-4 font-mono text-sm text-gray-700 dark:text-gray-300 disabled:opacity-60 disabled:cursor-not-allowed"
              [class.border-gray-300]="!isNaMissing(question)" [class.dark:border-gray-700]="!isNaMissing(question)"
              [class.border-error-500]="isNaMissing(question)"/>
            @if (isNaMissing(question)) {
              <p class="mt-1 text-xs text-error-600">A value is required while Not Applicable is enabled.</p>
            } @else {
              <p class="mt-1 text-xs text-gray-400">Lowercase letters, numbers and _ only. No spaces.</p>
            }
          </div>
          }
        </div>
      </ng-template>
    </div>
  } @else {
    <div class="rounded-2xl border border-dashed border-gray-300 bg-white p-10 text-center dark:border-gray-700 dark:bg-white/3">
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Select or add a question.
      </p>
    </div>
  }
  </section>
</div>
}

@if (showDiscardConfirm()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="cancelDiscard()">
  <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-900" (click)="$event.stopPropagation()">
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">Discard changes?</h3>
    <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
      {{ pendingChangesCount }} unsaved change{{ pendingChangesCount === 1 ? '' : 's' }} will be lost and the survey will be restored to its last saved state.
    </p>
    <div class="mt-5 flex justify-end gap-3">
      <button type="button" (click)="cancelDiscard()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Cancel
      </button>
      <button type="button" (click)="confirmDiscard()" class="rounded-lg bg-error-600 px-4 py-2 text-sm font-medium text-white hover:bg-error-700">
        Discard
      </button>
    </div>
  </div>
</div>
}

@if (showSaveConfirm()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="cancelSave()">
  <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-900" (click)="$event.stopPropagation()">
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">Save changes?</h3>
    <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
      {{ pendingChangesCount }} question{{ pendingChangesCount === 1 ? '' : 's' }} will be saved
      @if (newQuestionsCount > 0) {
        (<span class="text-success-600 dark:text-success-400">{{ newQuestionsCount }} new</span>
        @if (modifiedQuestionsCount > 0) { , }
        @else { ) }
      }
      @if (modifiedQuestionsCount > 0) {
        @if (newQuestionsCount === 0) { ( }
        <span class="text-warning-600 dark:text-warning-400">{{ modifiedQuestionsCount }} modified</span>)
      }
    </p>
    @if (saveError()) {
    <p class="mt-3 rounded-lg bg-error-50 px-3 py-2 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400">{{ saveError() }}</p>
    }
    <div class="mt-5 flex justify-end gap-3">
      <button type="button" (click)="cancelSave()" [disabled]="saving()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Cancel
      </button>
      <button type="button" (click)="confirmSave()" [disabled]="saving()" class="flex items-center gap-2 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-70">
        @if (saving()) {
          <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
          Saving...
        } @else {
          Save
        }
      </button>
    </div>
  </div>
</div>
}

@if (showLeaveConfirm()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
  <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-900">
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">Discard unsaved changes?</h3>
    <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
      You have {{ pendingChangesCount }} unsaved change{{ pendingChangesCount === 1 ? '' : 's' }}. If you leave now they will be lost.
    </p>
    <div class="mt-5 flex justify-end gap-3">
      <button type="button" (click)="cancelLeave()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Stay
      </button>
      <button type="button" (click)="confirmLeave()" class="rounded-lg bg-error-600 px-4 py-2 text-sm font-medium text-white hover:bg-error-700">
        Leave & discard
      </button>
    </div>
  </div>
</div>
}

@if (questionPendingDelete()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="cancelDelete()">
  <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-900" (click)="$event.stopPropagation()">
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">Delete question?</h3>
    <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
      "<span class="font-medium text-gray-700 dark:text-gray-300">{{ questionPendingDelete()?.title || questionPendingDelete()?.questionCode }}</span>" will be permanently removed.
    </p>
    @if (deleteError()) {
    <p class="mt-3 rounded-lg bg-error-50 px-3 py-2 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400">{{ deleteError() }}</p>
    }
    <div class="mt-5 flex justify-end gap-3">
      <button type="button" (click)="cancelDelete()" [disabled]="deleting()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Cancel
      </button>
      <button type="button" (click)="confirmDelete()" [disabled]="deleting()" class="flex items-center gap-2 rounded-lg bg-error-600 px-4 py-2 text-sm font-medium text-white hover:bg-error-700 disabled:opacity-70">
        @if (deleting()) {
          <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
          Deleting...
        } @else {
          Delete
        }
      </button>
    </div>
  </div>
</div>
}